// extracted by mini-css-extract-plugin
export var columnList = "_k5-0";